<template>
  <v-row justify="center">
    <v-dialog v-model="open" width="600px">
      <v-card class="pt-7">
        <v-row no-gutters class="px-6">
          <v-col cols="10">
            <span class="title textType3--text">
              {{ $t('message.pages.videoOffline.modal.title') }}
            </span>
            <br />
            <span
              v-html="$t('message.pages.videoOffline.modal.subtitle')"
              class="subtitle textType6--text"
            >
            </span>
          </v-col>
          <v-col cols="2" class="d-flex flex-row align-start justify-end">
            <v-icon style="cursor: pointer" @click="handleClose">
              mdi-close
            </v-icon>
          </v-col>
        </v-row>
        <v-card-text class="px-6 py-0 mt-6">
          <v-row no-gutters>
            <v-col
              v-for="(possibleTime, i) in possibleTimesList"
              cols="12"
              :key="i"
              :class="i === possibleTimesList.length - 1 ? 'mb-5' : ''"
            >
              <v-row no-gutters>
                <v-col cols="12">
                  <v-divider class="my-4" v-if="i != 0" />
                </v-col>
                <v-col cols="12">
                  <v-row no-gutters>
                    <v-card
                      class="d-flex align-center justify-center mr-1"
                      flat
                      color="background"
                    >
                      <v-btn
                        style="width: 24px !important"
                        icon
                        @click="handleSelectTime(possibleTime)"
                      >
                        <v-card
                          class="d-flex align-center justify-center elevation-0 rounded-pill"
                          width="20px"
                          height="20px"
                          :color="
                            isSelectedTime(possibleTime)
                              ? '#3F55EE'
                              : $vuetify.theme.dark
                              ? '#000000'
                              : '#FFFFFF'
                          "
                          :style="
                            isSelectedTime(possibleTime)
                              ? ''
                              : $vuetify.theme.dark
                              ? 'border: 2px solid #52577A'
                              : 'border: 2px solid #D0D1D9'
                          "
                        >
                          <v-card
                            v-if="isSelectedTime(possibleTime)"
                            :color="
                              isSelectedTime(possibleTime)
                                ? '#FFFFFF'
                                : !$vuetify.theme.dark
                                ? '#000000'
                                : '#FFFFFF'
                            "
                            width="10px"
                            height="10px"
                            flat
                            class="rounded-pill"
                          ></v-card>
                        </v-card>
                      </v-btn>
                    </v-card>
                    <v-col class="d-flex align-center justify-start ml-2">
                      <span class="optionsText textType3--text">
                        {{ possibleTime.text }}
                      </span>
                    </v-col>
                    <v-col
                      cols="7"
                      v-if="possibleTime.isOther && selectedTime.isOther"
                    >
                      <v-input
                        v-model="possibleTime.value"
                        :placeholder="
                          $t('message.pages.videoOffline.modal.daysTextfield')
                        "
                        dense
                        type="number"
                        outlined
                        hide-details
                      ></v-input>
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions
          :style="
            $vuetify.theme.dark
              ? 'border-top: 1px solid #363949'
              : 'border-top: 1px solid #edeef1'
          "
          class="py-8 pb-6"
        >
          <v-spacer></v-spacer>
          <base-btn class="mr-2" type="tertiary" @click="handleClose">
            {{ $t('message.cancel') }}
          </base-btn>
          <v-tooltip v-if="isConfirmDisabled" top class="tooltipBg">
            <template v-slot:activator="{ on, attrs }">
              <div v-bind="attrs" v-on="on" style="display: inline-block">
                <base-btn
                  type="primary"
                  :disabled="isConfirmDisabled"
                  @click="handleConfirm"
                >
                  {{ $t('message.confirm') }}
                </base-btn>
              </div>
            </template>
            <span style="background-color: black; color: white">
              {{ $t('message.pages.videoOffline.modal.tooltipMsg') }}
            </span>
          </v-tooltip>

          <base-btn
            v-else
            type="primary"
            :disabled="isConfirmDisabled"
            @click="handleConfirm"
          >
            {{ $t('message.confirm') }}
          </base-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
import i18n from '@/translations/lang'
import { mapMutations } from 'vuex'

export default {
  name: 'VideoPlayerOfflineModal',
  components: {},
  data: () => ({
    open: false,
    selectedTime: {
      text: `30 ${i18n.t('message.pages.videoOffline.days')}`,
      value: 30,
    },
    possibleTimesList: [],
  }),
  computed: {
    isConfirmDisabled() {
      if (this.selectedTime.isOther && !this.selectedTime.value) {
        return true
      } else {
        return false
      }
    },
  },
  mounted() {
    this.$root.$on('openVideoPlayerOfflineModal', (data) => {
      this.open = true
      this.selectedTime = data.selectedTime
      this.possibleTimesList = data.possibleTimes
      if (data.selectedTime.isOther) {
        this.possibleTimesList = this.possibleTimesList.map((time) => {
          if (time.isOther) return { ...data.selectedTime }
          return time
        })
      }
    })
  },
  beforeDestroy() {
    this.$root.$off('openVideoPlayerOfflineModal')
  },
  methods: {
    ...mapMutations('user', ['UPDATE_GLOBAL_SNACKBAR']),
    isSelectedTime(time) {
      if (this.selectedTime.value === time.value) return true
      if (this.selectedTime.isOther && time.isOther) return true
      return false
    },
    handleSnackbar(item) {
      if (!item) {
        item = i18n.t('message.changesSaved')
      }
      this.UPDATE_GLOBAL_SNACKBAR({
        open: true,
        text: item,
        type: 'success',
      })
    },
    handleSelectTime(time) {
      this.selectedTime = time
    },
    handleConfirm() {
      if (this.selectedTime.isOther)
        this.selectedTime = this.possibleTimesList.find((val) => val.isOther)
      this.$root.$emit('setOfflineVideoTime', this.selectedTime)
      this.handleSnackbar()
      this.handleClose()
    },
    handleClose() {
      this.$root.$emit('renameModalClosed')
      this.open = null
    },
  },
}
</script>

<style scoped>
.title {
  font-size: 18px;
}
.subtitle {
  font-size: 12px;
}
.optionsText {
  font-size: 14px;
}
.v-tooltip__content {
  background: black !important;
}
</style>
